import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowLeft, ShoppingCart } from "lucide-react";
import { Button } from "../components/ui/button";

const PaymentCancelPage = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("order_id");

  const colors = {
    green: { primary: "#2D8B4E", light: "#A8D5BA", dark: "#1A5632" },
    red: { primary: "#EF4444", light: "#FEE2E2" }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: colors.green.light }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-3xl p-8 text-center max-w-lg shadow-xl"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring" }}
          className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center"
          style={{ background: colors.red.light }}
        >
          <XCircle className="w-10 h-10" style={{ color: colors.red.primary }} />
        </motion.div>

        <h1 className="text-3xl font-bold mb-2" style={{ color: colors.green.dark }}>
          Payment Cancelled
        </h1>
        <p className="text-gray-600 mb-6">
          No worries! Your order has been cancelled and you haven't been charged. Your cart items are still saved.
        </p>

        <div className="space-y-3">
          <Link to="/marketplace" className="block">
            <Button 
              className="w-full h-12"
              style={{ background: colors.green.primary }}
            >
              <ShoppingCart className="w-4 h-4 mr-2" />
              Return to Seed Shop
            </Button>
          </Link>
          <Link to="/" className="block">
            <Button variant="outline" className="w-full h-12">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go to Home
            </Button>
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default PaymentCancelPage;
